import { apiClient, APIResponse, extractApiError, buildQuery } from './api';

export const budgetsAPI = {
  async getPresets() {
    try {
      const { data } = await apiClient.get('/budgets/presets/');
      return APIResponse.success(data);
    } catch (error) {
      return APIResponse.error(extractApiError(error, 'Não foi possível carregar os métodos.'));
    }
  },

  async getActiveMethod() {
    try {
      const { data } = await apiClient.get('/budgets/methods/active/');
      return APIResponse.success(data);
    } catch (error) {
      return APIResponse.error(extractApiError(error, 'Não foi possível carregar o método ativo.'));
    }
  },

  // CHANGE v2 §3: is_aspirational removido do payload.
  async createMethodFromPreset({ preset_id, customisations }) {
    try {
      const { data } = await apiClient.post('/budgets/methods/from-preset/', {
        preset_id,
        customisations,
      });
      return APIResponse.success(data);
    } catch (error) {
      return APIResponse.error(extractApiError(error, 'Não foi possível criar o método.'));
    }
  },

  async createMethod(payload) {
    try {
      const { data } = await apiClient.post('/budgets/methods/', payload);
      return APIResponse.success(data);
    } catch (error) {
      return APIResponse.error(extractApiError(error, 'Não foi possível guardar o método.'));
    }
  },

  async getOverview({
    year,
    month,
    periodStart,
    periodEnd,
    includeArchivedWithSpending = false,
  }) {
    try {
      const { data } = await apiClient.get(
        `/budgets/overview/${buildQuery({
          year,
          month,
          period_start: periodStart,
          period_end: periodEnd,
          include_archived_with_spending: includeArchivedWithSpending ? true : undefined,
        })}`,
      );
      return APIResponse.success(data);
    } catch (error) {
      return APIResponse.error(
        extractApiError(error, 'Não foi possível carregar o resumo do orçamento.'),
      );
    }
  },

  async setPlanningIncome({ planningIncomeMode, planningIncomeOverrideEur }) {
    try {
      const payload = {};
      if (planningIncomeMode) {
        payload.planning_income_mode = planningIncomeMode;
      }
      if (planningIncomeOverrideEur != null) {
        payload.planning_income_override_eur = planningIncomeOverrideEur;
      }
      const { data } = await apiClient.patch('/budgets/planning-income/', payload);
      return APIResponse.success(data);
    } catch (error) {
      return APIResponse.error(
        extractApiError(error, 'Não foi possível guardar o rendimento de planeamento.'),
      );
    }
  },
};

export const budgetAlertsAPI = {
  async list(params) {
    try {
      const { data } = await apiClient.get(`/budget-alerts/${buildQuery(params)}`);
      return APIResponse.success(data);
    } catch (error) {
      return APIResponse.error(
        extractApiError(error, 'Não foi possível carregar os alertas.'),
      );
    }
  },

  async dismiss(id) {
    try {
      const { data } = await apiClient.post(`/budget-alerts/${id}/dismiss/`);
      return APIResponse.success(data);
    } catch (error) {
      return APIResponse.error(
        extractApiError(error, 'Não foi possível dispensar o alerta.'),
      );
    }
  },
};
